import React from 'react'
import Navbar from '../components/Navbar'
import '../pages/contact.css'

function Contact() {
  return (
    <>
    <Navbar/>
    <div name='contact' className='contact-container'>
      <div class="form-container">
      <h2>Contact US</h2>
        <div className='contact-line'></div>
          <form action='https://getform.io/f/efb47928-07e4-4b4f-85fc-e461160b6bbf' method="POST">
            <label for="Name">Name</label>
            <input type="text" id="fname" name="firstname" placeholder="Your name.."/>
            <label for="Email">Email</label>
            <input type="text" id="lname" name="email" placeholder="Your Email.."/>
            <label for="subject">Message</label>
            <textarea id="subject" name="subject" placeholder="Write your suggession.."></textarea>
            <input type="submit" value="Submit"/>
          </form>
        </div>
    </div>
    </>
  )
}

export default Contact